//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import {
  StreamsDrawerStreamType,
  StreamsLaunchContext,
} from '@streams-drawer/streams-drawer-constants';
import { getStreamsDrawerLayout } from '@streams/streamsUtils';
import template from './streams-drawer-content.html';
import './streams-drawer-content.less';

import '@streams-drawer/streams-drawer-content/streams-drawer-empty-state/streams-drawer-empty-state';
import '@streams-drawer/streams-drawer-content/streams-drawer-grid-item/streams-drawer-grid-item';
import '@streams-drawer/streams-drawer-content/streams-drawer-list-item/streams-drawer-list-item';

class StreamsDrawerContent {
  public selectedStreamType: StreamsDrawerStreamType;
  public contentView: string;
  public launchContext: string;

  public streamsLaunchContext = StreamsLaunchContext;
  public taggedByCuralateStreamType = StreamsDrawerStreamType.TAGGED_BY_CURALTE;
  public connectStreamType = StreamsDrawerStreamType.CONNECT;

  public calculateStreamsDrawerLayout() {
    return getStreamsDrawerLayout(
      this.selectedStreamType,
      this.contentView,
      this.launchContext,
    );
  }
}

angular.module('curalate').component('streamsDrawerContent', {
  bindings: {
    contentView: '<',
    launchContext: '<',
    filterCount: '<',
    isEndOfContentReached: '<',
    isFetchingFilteredItems: '<',
    isFetchingNextItems: '<',
    isGalleryUploadsStream: '<',
    isRecommendationStream: '<',
    isTaggedByCuralateStream: '<',
    isConnectStream: '<',
    moderationStatus: '<',
    mentionsMyBrand: '<',
    isLegacyShareV2Vendor: '<',
    items: '<',
    onEndOfContentReached: '&',
    onOpenEditStreamModal: '&',
    shouldShowGalleryText: '<',
    shouldShowConnectText: '<',
    selectedStreamType: '<',
  },
  controller: StreamsDrawerContent,
  template,
});
